"use strict";

exports.__esModule = true;
exports.APIQueryController = void 0;
var _react = require("react");
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _querystring = require("querystring");
var _RestAPI = require("../../API/RestAPI");
var _dec, _class, _APIQueryController;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Makes an API request and makes the result available via a render-prop.
 */
var APIQueryController = exports.APIQueryController = (_dec = _RestAPI.RestAPIContext.withContext, _dec(_class = (_APIQueryController = /*#__PURE__*/function (_Component) {
  function APIQueryController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.hasMounted = false;
    _this.clearTimeoutId = null;
    _this.state = {
      loaded: false,
      fetching: true,
      reload: function reload() {
        return _this.makeRequest();
      },
      pagination: undefined,
      data: undefined,
      error: undefined,
      update: function update(setter) {
        if (_this.hasMounted) {
          _this.setState(function (_ref) {
            var data = _ref.data;
            return {
              data: setter(data)
            };
          });
        }
      }
    };
    return _this;
  }
  _inheritsLoose(APIQueryController, _Component);
  var _proto = APIQueryController.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.hasMounted = true;
    this.makeRequest();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.hasMounted = false;
    if (this.clearTimeoutId && typeof this.clearTimeoutId === "number") {
      clearTimeout(this.clearTimeoutId);
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;
    var _this$props = this.props,
      url = _this$props.url,
      method = _this$props.method,
      params = _this$props.params,
      query = _this$props.query,
      body = _this$props.body,
      pagination = _this$props.pagination;
    if (url !== prevProps.url || method !== prevProps.method || !(0, _reactFastCompare["default"])(params, prevProps.params) || !(0, _reactFastCompare["default"])(query, prevProps.query) || !(0, _reactFastCompare["default"])(body, prevProps.body) || !(0, _reactFastCompare["default"])(pagination, prevProps.pagination)) {
      if (this.clearTimeoutId && typeof this.clearTimeoutId === "number") {
        clearTimeout(this.clearTimeoutId);
        this.clearTimeoutId = setTimeout(function () {
          _this2.makeRequest();
        }, 500);
      } else {
        this.clearTimeoutId = setTimeout(function () {
          _this2.makeRequest();
        }, 0);
      }
    }
  };
  _proto.makeRequest = function makeRequest() {
    var _this3 = this;
    var _this$props2 = this.props,
      api = _this$props2.api,
      url = _this$props2.url,
      params = _this$props2.params,
      query = _this$props2.query,
      method = _this$props2.method,
      body = _this$props2.body,
      onData = _this$props2.onData,
      normalizeResponse = _this$props2.normalizeResponse,
      load = _this$props2.load;
    if (!this.state.fetching) {
      this.setState({
        fetching: true
      });
    }
    var target = url || "";
    if (!url && !load) {
      throw new Error("One of url or load prop must be set.");
    }
    if (url && load) {
      throw new Error("Only one of url or load prop must be set.");
    }
    if (params) {
      target = target.replace(/:(\w+)/g, function (_, key) {
        return params[key];
      });
    }
    if (query) {
      var search = (0, _querystring.stringify)(query);
      target += "?" + search;
    }
    return (load ? load() : api.makeRequest(target, {
      method: method,
      body: body
    })).then(function (data) {
      _this3.clearTimeoutId = null;
      if (!_this3.hasMounted) {
        return;
      }
      var content = data.content,
        paginationParams = data.paginationParams;
      var dataToNormalize = content ? content : data;
      var normalizedData = typeof normalizeResponse === "function" ? normalizeResponse(dataToNormalize) : dataToNormalize;
      if (onData) {
        onData(normalizedData);
      }
      return _this3.setState({
        loaded: true,
        fetching: false,
        data: normalizedData,
        pagination: (paginationParams == null ? void 0 : paginationParams.totalElements) != null ? paginationParams : null,
        error: undefined
      });
    }, function (error) {
      _this3.clearTimeoutId = null;
      if (!_this3.hasMounted) {
        return;
      }
      return _this3.setState({
        fetching: false,
        error: error
      });
    });
  };
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return APIQueryController;
}(_react.Component), _APIQueryController.defaultProps = {
  method: "GET",
  api: undefined,
  url: ""
}, _APIQueryController)) || _class);